import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ParentService } from '../services/parent.service';
import { MatTableDataSource } from "@angular/material/table";
import { Parent } from 'backend/interfaces/parent.interface';
import { Observable } from 'rxjs';
import { faEye, faPlus, faSave, faSearch, faUndo } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { SidenavActions, SideNavService } from '../services/side-nav.service';
import { Business } from 'backend/interfaces/business.interface';
import { BusinessService } from '../services/business.service';


@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
  loading = false;
  faHome = faEye;
  faSearch = faSearch;
  faUndo = faUndo;
  displayLimit = 10;
  page = 0;
  faSave = faSave;
  
  sideNavActions = SidenavActions;
  @ViewChild('parentsPaginator') parentsPaginator: MatPaginator;
  parents: Business[] = [];
  dataSource: MatTableDataSource<Business>;
  pageEvent: PageEvent;
  parentCount;
  faPlus = faPlus;
  displayedColumns: string[] = [
    'Name',
    'Address',
    'Category',
    'Mobile',
    'Email',
    'Actions'
  ];
  search = {name: ''};
  constructor(public businessService: BusinessService, private router: Router, public sidenav: SideNavService) { 
  }
  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.businessService.businessSearch$.subscribe(res => {
      this.search = res;
    });
    this.businessService.businessCount$.subscribe(res => {
      this.parentCount = res;
    })
    this.businessService.businesses$.subscribe(res => {
      console.log(res)
      this.parents = res;
      this.dataSource = new MatTableDataSource(this.parents);
    })
    this.loading = false;
  }

  openParent(parent: Business){
    console.log(parent)
    this.businessService.activatedBusiness.next(parent)
    this.router.navigate(['admin', 'business', parent.id]);
  }

  async createParent(): Promise<void> {
    const newParent: Business = {
      Name: '',
      RegistrationDate: '',
      RegistrationNumber: '',
      Address: '',
      Mobile: '',
      Email: '',
      Status: '',
      Notes: '',
      InformedDataConsent: false,
      OwnerID: '',
      Category: null
    };
    this.businessService.activatedBusiness.next(newParent);
    this.router.navigate(['admin', 'parent']);
  }

  async createBusiness(){
    this.businessService.activatedBusiness.next(null);
    this.sidenav.open(SidenavActions.NewBusiness);
  }

  async pageParents(e?: PageEvent): Promise<void>{
    this.loading = true;
    if(e){
      this.displayLimit = e.pageSize;
      this.page = e.pageIndex;
    }
    await this.businessService.getBusinesses(this.displayLimit, this.page);
    this.loading = false;
  }

  openSideNav(action: SidenavActions): void {
    this.sidenav.open(action);
  }

  reloadParents(){
    this.businessService.businessSearch.next({name: ''});
    this.businessService.getBusinessCount();
    this.businessService.getBusinesses(10, 0);
  }

  parentsImport = [];

  async saveProfiles() {
    // this.loading = true;
    // this.businessService
    //   .saveBusiness(this.parentsImport)
    //   .then(() => {
    //     this.loading = false;
    //   })
    //   .catch((err) => {
    //     this.loading = false;
    //   });
  }

}
